import { sanitize } from 'dompurify';
import React, { FC, useEffect, useRef, useState } from 'react';

import { Modal } from './Modal';

export interface AnnouncementModalProps {
  body?: string;
  title?: string;
  onClose?: () => void;
}

export const AnnouncementModal: FC<AnnouncementModalProps> = ({ title, body, onClose }) => {
  const [visible, setVisible] = useState(true);
  const timerRef = useRef<NodeJS.Timeout>();
  const isVisible = visible && !!body;

  const handleClose = () => {
    setVisible(false);
    timerRef.current = setTimeout(() => {
      onClose?.();
    }, 500);
  };

  useEffect(() => {
    return () => {
      clearTimeout(timerRef.current);
    };
  }, []);

  return (
    <Modal show={isVisible} onClose={handleClose} title={title}>
      <div
        className="oejr-announcement-modal"
        dangerouslySetInnerHTML={{ __html: sanitize(body || '') }}
      />
    </Modal>
  );
};
